export class AboutMe {
  constructor(
    public background: string,
    public experience: string,
    public education: string,
    public proficiencies: string,
    public hobbies: string
  ) {}
}


// WEBPACK FOOTER //
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/models/aboutMe.model.ts